import useTranslator from "../../hooks/useTranslator";
import { haveValue } from "../../helper/common";
import styles from "./BasicInfoModal.module.css";

const CompanyOnboardingInfoSection = ({
  isCompany,
  formData,
  handleInputChange,
  errors,
}) => {
  const { _t } = useTranslator();

  if (!isCompany) return null;

  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        gap: "16px",
      }}
    >
      <div className="company-info-banner-wrap">
        <div className="company-info-banner-content">
          {_t("companyTenantBannerText", "Company tenant registration banner")}
        </div>
      </div>

      <div className="company-section-divider">
        {_t("companyDetailsSection", "Company section headers")}
      </div>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          gap: "16px 18px",
        }}
      >
        <div className={styles.field} style={{ gridColumn: "1 / -1" }}>
          <div
            className={`${styles.control} ${errors.company_legal_name ? styles.controlError : ""}`}
          >
            <label>{_t("legalName", "Company data field labels")}</label>
            <input
              type="text"
              name="company_legal_name"
              placeholder={_t(
                "companyLegalNamePlaceholder",
                "Company data field placeholders"
              )}
              value={formData.company_legal_name || ""}
              onChange={handleInputChange}
            />
          </div>
          {errors.company_legal_name && (
            <p className="error-message">{errors.company_legal_name}</p>
          )}
        </div>

        <div className={styles.field}>
          <div
            className={`${styles.control} ${errors.company_cif ? styles.controlError : ""}`}
          >
            <label>{_t("taxIdCif", "Company data field labels")}</label>
            <input
              type="text"
              name="company_cif"
              placeholder={_t(
                "cifPlaceholder",
                "Company data field placeholders"
              )}
              value={formData.company_cif || ""}
              onChange={handleInputChange}
              maxLength={9}
            />
          </div>
          {errors.company_cif && (
            <p className="error-message">{errors.company_cif}</p>
          )}
        </div>

        <div className={styles.field}>
          <div
            className={`${styles.control} ${errors.company_type ? styles.controlError : ""}`}
          >
            <label>{_t("companyType", "Company data field labels")}</label>
            <select
              name="company_type"
              value={formData.company_type || ""}
              onChange={handleInputChange}
              style={{
                color:
                  (!haveValue(formData?.company_type) ||
                    formData?.company_type === "") &&
                  "#7f7f7f",
              }}
            >
              <option value="" disabled>
                {_t("pleaseSelect")}
              </option>
              <option value="SL">
                {_t("limitedCompanySl", "Company type options")}
              </option>
              <option value="SA">
                {_t("publicLimitedCompanySa", "Company type options")}
              </option>
              <option value="cooperativa">
                {_t("cooperative", "Company type options")}
              </option>
              <option value="other">{_t("other")}</option>
            </select>
            <img
              src="/images/down-arrow-grey.svg"
              className="downArrow"
              alt=""
            />
          </div>
          {errors.company_type && (
            <p className="error-message">{errors.company_type}</p>
          )}
        </div>

        <div className={styles.field} style={{ gridColumn: "1 / -1" }}>
          <div
            className={`${styles.control} ${errors.company_cnae ? styles.controlError : ""}`}
          >
            <label>
              {_t("cnaeBusinessActivity", "Company data field labels")}
            </label>
            <input
              type="text"
              name="company_cnae"
              placeholder={_t(
                "cnaePlaceholder",
                "Company data field placeholders"
              )}
              value={formData.company_cnae || ""}
              onChange={handleInputChange}
            />
          </div>
          {errors.company_cnae && (
            <p className="error-message">{errors.company_cnae}</p>
          )}
        </div>
      </div>

      <div className="company-section-divider" style={{ marginTop: "4px" }}>
        {_t("legalRepresentativeSection", "Company section headers")}
      </div>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          gap: "16px 18px",
        }}
      >
        <div className={styles.field}>
          <div
            className={`${styles.control} ${errors.company_representative_position ? styles.controlError : ""}`}
          >
            <label>{_t("position", "Company data field labels")}</label>
            <select
              name="company_representative_position"
              value={formData.company_representative_position || ""}
              onChange={handleInputChange}
              style={{
                color:
                  (!haveValue(formData?.company_representative_position) ||
                    formData?.company_representative_position === "") &&
                  "#7f7f7f",
              }}
            >
              <option value="" disabled>
                {_t("pleaseSelect")}
              </option>
              <option value="sole_administrator">
                {_t(
                  "soleAdministrator",
                  "Legal representative position options"
                )}
              </option>
              <option value="authorized_signatory">
                {_t(
                  "authorizedSignatory",
                  "Legal representative position options"
                )}
              </option>
              <option value="ceo">
                {_t("ceo", "Legal representative position options")}
              </option>
            </select>
            <img
              src="/images/down-arrow-grey.svg"
              className="downArrow"
              alt=""
            />
          </div>
          {errors.company_representative_position && (
            <p className="error-message">
              {errors.company_representative_position}
            </p>
          )}
        </div>

        <div className={styles.field}>
          <div
            className={`${styles.control} ${errors.identity_number ? styles.controlError : ""}`}
          >
            <label>{_t("representativeId", "Company data field labels")}</label>
            <input
              type="text"
              name="identity_number"
              placeholder={_t(
                "enterYourRepresentativesId",
                "Text used in onboarding process"
              )}
              value={formData.identity_number || ""}
              onChange={handleInputChange}
              maxLength={9}
            />
          </div>
          {errors.identity_number && (
            <p className="error-message">{errors.identity_number}</p>
          )}
          <p className="company-field-hint">
            {_t("sameDocumentEnteredAbove", "Company data field hints")}
          </p>
        </div>
      </div>
    </div>
  );
};

export default CompanyOnboardingInfoSection;
